import { RouteConfig } from 'vue-router';
import ProfileView from '@/app/views/ProfileView.vue';
import DetailsView from '@/app/views/DetailsView.vue';
import WizardView from '@/app/views/WizardView.vue';
import ConsumerProfileView from '@/app/views/ConsumerProfileView.vue';
import DeleteAccountConfirmationView from '@/app/views/DeleteAccountConfirmationView.vue';

export const routes: RouteConfig[] = [
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView
  },
  {
    path: '/details',
    name: 'details',
    component: DetailsView
  },
  {
    path: '/consumer-profile',
    name: 'consumer-profile',
    component: ConsumerProfileView
  },
  {
    path: '/delete-account-confirmation/',
    name: 'delete-account-confirmation',
    component: DeleteAccountConfirmationView
  },
  {
    path: '/',
    name: 'wizard',
    component: WizardView
  }
];
